import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import PpsPage from "@/pages/PpsPage";
import MudSinkPage from "@/pages/MudSinkPage";
import SitBuddyPage from "@/pages/SitBuddyPage";
import NeckCreeperPage from "@/pages/NeckCreeperPage";
import HornetPage from "@/pages/HornetPage";
import AdminPage from "@/pages/AdminPage";

export const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -64, duration: 1.5 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => scrollToSection(hash.slice(1)), 400);
      return () => clearTimeout(t);
    }
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-coal font-body text-white antialiased">
      <BrowserRouter>
        <ScrollManager />
        <div className="grain" aria-hidden="true" />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/pps" element={<PpsPage />} />
          <Route path="/mud-sink" element={<MudSinkPage />} />
          <Route path="/sit-buddy" element={<SitBuddyPage />} />
          <Route path="/neck-creeper" element={<NeckCreeperPage />} />
          <Route path="/hornet" element={<HornetPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{ style: { background: "#121212", border: "1px solid #262626", color: "#fff", borderRadius: 0 } }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
